import React, { useState, useEffect } from 'react';
import firebase from '../../config/firebaseConfig';
import { useSelector } from 'react-redux';
import { ListGroup, Form, Button, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';

const QuickNotesWidget = () => {
  const auth = useSelector((state) => state.firebase.auth);
  const [notes, setNotes] = useState([]);
  const [inputValue, setInputValue] = useState('');

  // 📡 1. ÉCOUTEUR FIRESTORE EN TEMPS RÉEL (Cloisonné par userId)
  useEffect(() => {
    if (!auth.uid) return;

    const db = firebase.firestore();
    const unsubscribe = db.collection('quickNotes')
      .where('userId', '==', auth.uid)
      .onSnapshot((snapshot) => {
        const list = [];
        snapshot.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));

        // 🎯 TRI LOCAL JAVASCRIPT : On trie par date proprement ici sans dépendre de Firebase !
        list.sort((a, b) => {
          const dateA = a.createdAt?.seconds || 0;
          const dateB = b.createdAt?.seconds || 0;
          return dateA - dateB; // Trie du plus ancien au plus récent
        });

        setNotes(list);
      }, (err) => console.error("Erreur Post-it :", err));

    return () => unsubscribe();
  }, [auth.uid]);

  // ➕ 2. AJOUT RAPIDE
  const handleAddNote = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) return;

    try {
      await firebase.firestore().collection('quickNotes').add({
        text: inputValue.trim(),
        userId: auth.uid,
        createdAt: new Date()
      });
      setInputValue('');
    } catch (err) {
      toast.error("Impossible d'ajouter la note éphémère");
    }
  };

  // ❌ 3. SUPPRESSION RAPIDE (Idée cochée / achetée)
  const handleDeleteNote = async (noteId) => {
    try {
      await firebase.firestore().collection('quickNotes').doc(noteId).delete();
    } catch (err) {
      toast.error("Erreur de suppression");
    }
  };

  return (
    <XyzTransition appear xyz='fade stagger delay-4 duration-15'>
    <div className="w-100 bg-dark bg-opacity-50 border border-2 border-warning border-opacity-25 rounded-3 p-3 mb-3 shadow-lg h-100 text-light select-none"
        style={{ boxShadow: '0 0 15px rgba(255, 193, 7, 0.05)' }}>

      <h5 className="text-center text-warning fw-semibold mb-3" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
        <span>📝</span> Pense-bête / Liste Rapide
      </h5>

      {/* Formulaire d'ajout rapide inline */}
      <Form onSubmit={handleAddNote} className="mb-3">
        <InputGroup size="sm">
          <Form.Control
            type="text"
            placeholder="Ex: Acheter du pain, idée de projet..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            required
            className="bg-dark text-light border-secondary border-opacity-50 text-white"
          />
          <Button variant="warning" type="submit" className="fw-bold px-3">
            ➕
          </Button>
        </InputGroup>
      </Form>

      {/* Liste des Post-its défilante */}
      <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="custom-scrollbar">
        {notes.length === 0 ? (
          <p className="text-white text-center small my-3 italic">L'ardoise est vide ! ✨</p>
        ) : (
            <ListGroup variant="flush">
              {notes.map((note) => (
                <ListGroup.Item
                  key={note.id}
                  className="bg-transparent text-light border-secondary border-opacity-25 px-1 py-2 d-flex justify-content-between align-items-center"
                  style={{ fontSize: '0.9rem' }}
                >
                  <div className="d-flex align-items-center gap-2 text-wrap" style={{ maxWidth: '85%' }}>
                    <span className="text-warning-50">•</span>
                    <span>{note.text}</span>
                  </div>
                  <Button
                    variant="link"
                    className="text-danger p-0 text-decoration-none"
                    onClick={() => handleDeleteNote(note.id)}
                    style={{ fontSize: '0.85rem', lineHeight: '1' }}
                    title="Supprimer la note"
                  >
                    ✕
                </Button>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
      </div>
    </div>
    </XyzTransition>
  );
};

export default QuickNotesWidget;
